<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">

            <h1>😸 Rediscovering Your Financial Toys 🪀</h1>
    <p>Hello, Canadian savers and investors! Once again, it's time to meander through the maze of unclaimed property. Picture this: assets and accounts, forgotten like a cat's toy under the sofa, just waiting to be rediscovered. Let's pounce into the world of these hidden treasures, shall we?</p>
    
    <h2>Lost Treasures: Forgotten Accounts and Investments</h2>
    <p>It's all too easy to lose track of our financial footprints. Consider the short-term job with its fleeting benefits, like a group RRSP or a pension plan, often left behind in the dust of new opportunities. Or the bank account, opened during those university years, now lurking in the shadows of our memory. These lost assets, much like a cat's momentarily forgotten toy, are out there, waiting to be claimed. They're not lost - just momentarily out of sight and mind.</p>
    
    <h2>The Curious Case of Unclaimed Property</h2>
    <p>Unclaimed property is more common than one might think. It's the money that sits in accounts, untouched and unremembered, often due to life's rapid transitions or simple forgetfulness. These financial assets, whether they are old bank accounts, uncashed checks, or neglected investment accounts, are like hidden gems in the vast landscape of our financial lives. They remain there, silently accumulating, potentially holding significant value over time.</p>

    <h2>Every Dollar Counts: The Importance of Tracking Investments</h2>
    <p>Why, you might ask, does it matter? Well, in the world of personal finance, every dollar truly counts. Tracking your investments, no matter how small or seemingly insignificant, is akin to a cat keeping a watchful eye on all corners of its territory. These forgotten funds can contribute to your overall financial health, supporting future plans or emergency needs. So, it's crucial, dear readers, to keep a detailed ledger of your financial history. A dollar today could be a stepping stone to your next financial milestone.</p>

    
    <p>Just as a cat eventually rediscovers its long-lost toy, it's time for us to unearth these unclaimed assets. They are not just numbers on a paper; they represent hard-earned resources that can bolster your financial wellbeing. It's a journey of reconnection with your financial past, one that can surprisingly boost your present and future.</p>


    <h2>Unclaimed Bank Balances: Reclaim What's Yours</h2>
    <p>Did you know that forgotten financial products, like bank accounts and deposits, can become 'unclaimed' if not used for a certain period? In Canada, federally regulated financial institutions will consider the balance unclaimed after 10 years of inactivity. They then transfer these unclaimed balances to the Bank of Canada. However, this applies only to products in Canadian currency. For foreign currency products, like U.S dollar accounts, check directly with your financial institution.</p>

    <h3>Timeline for Unclaimed Balances</h3>
    <p>Financial institutions are required to make efforts to contact you at different stages of inactivity:
        <ul>
            <li><strong>2 years:</strong> After 2 years of inactivity.</li>
            <li><strong>5 years:</strong> After 5 years of inactivity.</li>
            <li><strong>9 years:</strong> After 9 years of inactivity, with a final notice explaining the upcoming transfer of your balance to the Bank of Canada if unclaimed.</li>
        </ul>
    </p>
    <p>Balances less than $1,000 are held for 30 years by the Bank of Canada, and those $1,000 or more for 100 years. It's important to keep track of your financial products to ensure you don't lose out on your hard-earned money.</p>

    <h3>How to Check for Unclaimed Balances</h3>
    <p>Before transferring an unclaimed balance, your financial institution will try to contact you at your last known address. Notices are typically sent in January following each inactivity period. If you suspect you might have unclaimed balances, it's worth checking out.  Just remember though that your financial institution will never ask you for your personal information so always feel free to question if someone doesn't feel right.  Just like a cat always be cautious and curious.</p>

    <p>Alberta, British Columbia and Quebec each have specific laws pertaining to unclaimed property which we've linked down below </p>

    <h3>Checklist for Finding Unclaimed Money</h3>
    <p>Think back to your previous jobs, old bank accounts, or deposits you might have forgotten. Here's a handy checklist to help you trace any unclaimed money:
        <ul>
            <li>✅ Review your employment history for any group RRSP or pension plans.</li>
            <li>✅ Recall any bank accounts opened during major life events, like university or moving to a new city.</li>
            <li>✅ Consider reaching out to financial institutions where you've previously held accounts.</li>
        </ul>
    </p>
     <!-- Special Section for Links to Provinces and Regulators -->
     <h2>Find Your Unclaimed Treasures</h2>
    <p>To embark on your treasure hunt for unclaimed property, visit the following resources. They are your maps and tools in this quest for financial rediscovery:</p>

    <p>The real fun part is searching for friends and family that may have undiscovered money.  My hooman found quite a few friends and family members that had unclaimed money and sent this over to them.  Hoping she ended up at least getting a delicous dinner out of it! </p>
   
    <div class="stylish-links">
          <h3>🔗 Important Links 🖇️</h3>
          <ul>
            <li><a href="https://www.unclaimedproperties.bankofcanada.ca/" target="_blank">Bank of Canada Unclaimed Properties Office</a></li>
            <li><a href="https://www5.services.mrq.gouv.qc.ca/MrqAnonyme/BR/BR01/BR01A1_01A_ConsulterBNR_PC/P_Consultation.aspx?CLNG=A" target="_blank">Revenue Quebec - Unclaimed Property Search </a></li>
            <li><a href="https://unclaimedproperty.alberta.ca/publicTracs/searchUnclaimedProperty.do?event=init" target="_blank">Alberta - Treasury and Finance Board</a></li>
            <li><a href="https://www.bcunclaimed.ca/search" target="_blank">BC - Office of the Comptroller General</a></li>
          </ul><br><br><br><br><br><br>
        </div></div></div></div>
  
</template>


<script>
</script>



<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: white;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>